module.exports = __webpack_public_path__ + "static/media/treatment_fix_org.f8cca427.png";